module.exports = new __parcel__URL__("NWBrickCon.69588f3e.jpeg").toString();